let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("x1hZ3")).then(() => parcelRequire('cbo1b'));